fragment AssignedUserFragment on User {
    id
    name
    emailAddresses {
        address
    }
    avatarUrl
    initials
}
